import React from 'react'
import { useNavigate } from 'react-router-dom';

interface DateOfProductionIsLateProps {
    goToSimulator?: (e: string) => void;
    onClose: () => void;
    leadId: string;
    navigateToSmilator: (e: any) => void;

}

const DateOfProductionIsLate: React.FC<DateOfProductionIsLateProps> = ({ goToSimulator, onClose, leadId, navigateToSmilator }) => {

    const navigate = useNavigate();

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const gotoSimulatorFunc = (e: any) => {
        localStorage.setItem('leadId', leadId)
        if (goToSimulator ) {
            navigateToSmilator(e)
            goToSimulator(leadId)
        }
        navigate('/Simulator');
    }



    return (
        <div
            onClick={handleOverlayClick}
            style={{
                position: 'absolute',
                top: 100,
                left: 0,
                right: 0,
                bottom: 0,
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 300,
                    height: 200,
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                {/* create messege for success from server */}

                <>
                    <h2>שגיאה</h2>
                    <p style={{ color: 'red', fontSize: 20 }}> {"תאריך תחילה אינו בתוקף"} </p>
                    <button onClick={(e: any) => gotoSimulatorFunc(e)} style={{
                        margin: '10px',
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}>
                        לסימולטור
                    </button>
                    <button onClick={navigateToSmilator} style={{
                        margin: '10px',
                        padding: '10px 20px',
                        backgroundColor: '#6c757d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}>
                        ביטול
                    </button>
                </>
            </div>
        </div>
    )
}

export default DateOfProductionIsLate